<template>
  <div class="row">
    <div class="col-12">
      <div class="modal-map">
        <parking-map v-if="moreInfoArray.length > 0" v-model="moreInfoArray" :more="true" />
      </div>
    </div>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import { ParkingMap } from "@/components";

export default {
  name: "MapTab",
  components: { ParkingMap },
  computed: {
    moreInfo: sync("modals/moreInfo"),
    moreInfoArray() {
      return [{ product: this.moreInfo }];
    }
  }
};
</script>